export enum Keys {
  'C',
  'C#/Db',
  'D',
  'D#/Eb',
  'E',
  'F',
  'F#/Gb',
  'G',
  'G#/Ab',
  'A',
  'A#/Bb',
  'B'
}

export enum TimeSignature {
  '3/4',
  '4/4',
  '6/8',
  '6/4',
  '12/8'
}

export type SongsFilter = Keys | TimeSignature | number | string
